export default {
  'Home.AccountCodeLogin': 'アカウント認証コードログイン',
  'Home.Pleaseenteryourphonenumberoremail':
    '電話番号またはメールアドレスを入力してください',
  'Home.Pleaseenteryouraccount': 'アカウントを入力してください',
  'Home.PleaseenteryourphonenumberoremailSure':
    '正しい電話番号またはメールアドレスを入力してください',
  'Home.Pleaseentertheverificationcode': '認証コードを入力してください',
  'Home.PleaseentertheverificationcodeSure':
    '正しい認証コードを入力してください',
  'Home.PleaseCode': '認証を完了してください',
  'Home.GetVerificationCode': '認証コードを',
  'Home.Login&Register': 'ログイン & サインアップ',
  'Home.AccountPasswordLogin': 'アカウントとパスワードでログイン',
  'Home.Pleaseenteryourpassword': 'パスワードを入力してください',
  'Home.Login': 'ログイン',
  'Home.Profile': '個人情報',
  'Home.BasicInformation': '基本情報',
  'Home.AccountManagement': 'アカウント管理',
  'Home.PhoneSettings': 'モバイル設定',
  'Home.EmailSettings': 'メール設定',
  'Home.ChangePassword': 'パスワードを変更',
  'Home.UserLogout': 'ユーザーの退会',
  'Home.PhoneAccount': 'モバイルアカウント',
  'Home.EmailAccount': 'メールアカウント',
  'Home.RealName': '名前',
  'Home.Save': '保存',
  'Home.SecurityAuthentication': 'セキュリティ認証',
  'Home.BindNewPhoneNumber': '新しい電話番号を登録',
  'Home.SendTip1': '電話番号{phone} に認証コードを送信して、本人確認を行います',
  'Home.Next': '次へ',
  'Home.SendTip2':
    'メールアドレス{email} に認証コードを送信して、本人確認を行います',
  'Home.BindNewEmail': '新しいメールアドレスを登録',
  'Home.SetNewPassword': '新しいパスワードを設定',
  'Home.LogoutConfirmation': 'アカウントの削除確認',
  'Home.Logout': 'ログアウト',
  'Home.Nosettings': '設定はありません',
  'Home.Pleaseenteryourrealname': 'お名前を入力してください',
  'Home.Modifiedsuccessfully': '変更が成功しました',
  'Home.Binding': '登録',
  'Home.Pleaseenteryourphonenumber': '電話番号を入力してください',
  'Home.PleaseenteryourphonenumberSure': '正しい電話番号を入力してください',
  'Home.PhoneTip1':
    '電話番号が登録されていません。電話番号を入力して登録してください',
  'Home.PhoneTip2': '電話番号は既に登録されています。確認してください',
  'Home.PhoneNumber': '電話番号',
  'Home.Email': 'メールアドレス',
  'Home.Confirmmodifications': '変更を確定',
  'Home.Securityverification': 'セキュリティ認証',
  'Home.Bind1': '新しい電話番号を登録',
  'Home.EmailTip1': 'メールアドレスは既に登録されています。確認してください',
  'Home.EmailTip2':
    'メールアドレスが登録されていません。メールアドレスを入力して登録してください',
  'Home.EmailTip3': 'メールアドレスを入力してください',
  'Home.EmailTip4': '正しいメールアドレスを入力してください',
  'Home.Password': 'パスワード',
  'Home.PasswordTip1':
    'パスワードは8〜16文字で、英字 / 数字 / 記号のうち2種類を含む必要があります',
  'Home.PasswordTip2':
    'パスワードを入力してください。8〜16文字で、英字 / 数字 / 記号のうち2種類を含む必要があります',
  'Home.Confirmpassword': 'パスワードの確認',
  'Home.PasswordTip3': 'もう一度パスワードを入力してください',
  'Home.PasswordTip4': '2回入力したパスワードが一致しません',
  'Home.Tip1': '注意してください！アカウント削除後は、データを復元できません',
  'Home.Tip2': 'アカウント削除を確認',
  userAccountVerifyRules:
    '名前の長さは1～64文字をサポートします。また、先頭または末尾にスペースを使用することはできません。',

  'Home.PasswordError10Times':
    'パスワードを何度も間違えた場合は、販売店に連絡してパスワードをリセットするか、認証コードを使用してログインし、ログイン後にパスワードを変更してください。',

  'Home.oldPasswordToNew': '古いパスワードを新しいものに変更',
  'Home.codeToNew': '確認コードで新しいパスワードに変更',
  'Home.Pleaseentertheoldpassword': '古いパスワードを入力してください',
  'Home.Pleaseenterthenewpassword': '新しいパスワードを入力してください',
  'Home.PleaseenterthenewpasswordSure': '正しいパスワードを入力してください',
  'Home.Pleaseenterthenewpasswordagain': '新しいパスワードを再入力してください',
  'Home.PleaseenterthenewpasswordagainSure': 'パスワードが一致しません',
  'Home.WeakPasswordTip':
    'パスワードは英字と数字を少なくとも1つずつ含み、8文字以上である必要があります',
  'Home.oldPassword': '古いパスワード',
  'Home.newPassword': '新しいパスワード',
  'Home.confirmPassword': 'パスワードを確認',
  'Home.UpdateSuccess': 'パスワードの更新が成功しました',
  'Home.PasswordError': 'アカウントやパスワードが正しくありません',
  'Home.ConfirmRequired': '確認用のパスワードを入力してください',
  'Home.oldPasswordToLogOut': '古いパスワードでログアウト',
  'Home.CodeToLogOut': '確認コードでログアウト',
  'Login.Agree': '私たちの利用規約に同意する',
  'Login.AgreeError': 'まずは規約に同意してください',
};
